<template>
  <a href="javascript:false" :class="cls" @click="onClick"><slot></slot></a>
</template>

<style scoped lang="scss">
  a {
      color: white !important;

      &.no-u {
        text-decoration: none;
      }

      &.u {
        text-decoration: underline;
      }
  }

  @media (hover: hover) {
    a {
      &.no-u:hover {
          text-decoration: underline;
      }

      &.u:hover {
          text-decoration: none;
      }
    }
  }
</style>

<script>
export default {
  name: 'LinkButton',
  props: ['u'],
  computed: {
    cls () {
      return this.u ? 'u' : 'no-u'
    }
  },
  methods: {
    onClick (ev) {
      ev.preventDefault()
      ev.stopPropagation()
      this.$emit('click')
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/LinkButton.vue